import { useSelector } from 'react-redux';
import { getAllGalleryImagesLow } from '../store/gallery-slice';
import { urlParam } from '../utils/url-param';

export default function useGalleryExist() {
  const envMobileExist = urlParam('env');

  const { interiorGalleryLow, exteriorGalleryLow } = useSelector(
    getAllGalleryImagesLow,
  );

  const interiorgallery =
    interiorGalleryLow?.length > 0 || exteriorGalleryLow?.length > 0;

  return !envMobileExist && interiorgallery;
}
